import {DomainStore} from 'shared/store';
import {observable, action} from 'mobx';
import {endpoints, types} from 'main/tools';
import {NmbrEmployee} from 'main/stores/nmbr';

class NmbrPageState {
  store = new DomainStore();

  @observable erroredNmbrEmployees = [];

  @action async load() {
    await this.store._compose([
      endpoints.NMBR.EMPLOYEES.ERRORED
    ]);
    this.erroredNmbrEmployees = this.store._getAll(types.NMBR.EMPLOYEE, NmbrEmployee);
  }
}

export default NmbrPageState;
